module.exports = __webpack_public_path__ + "static/media/promotional_6.185cb8ed.png";